// extracted by mini-css-extract-plugin
export default {"container":"InvalidPage_container__1Dgv9","content":"InvalidPage_content__Vaj0g","wrapper":"InvalidPage_wrapper__Qt5Wh","title":"InvalidPage_title__2c7ak"};